import { cn } from "@/lib/utils";

import PropHeroLogo from "./PropHeroLogo";

type AuthScreenFooterProps = {
  className?: string;
};

/**
 * Brand mark for the auth shell. Placement (top on mobile, bottom of the
 * left column on desktop) belongs to AuthSplitLayout.
 */
function AuthScreenFooter({ className }: AuthScreenFooterProps) {
  return (
    <footer className={cn("flex w-full justify-center", className)}>
      <PropHeroLogo />
    </footer>
  );
}

export default AuthScreenFooter;
